import { z, ZodTypeAny } from 'zod';
import type { FieldSchema } from '@/hooks/useInsuranceTypeSchema';

export function widgetForDataType(field: FieldSchema): string {
  if (field.data_type === 'fk' && field.fk_resource === 'vehicles.VehicleVariant') return 'vehicle-search';
  switch (field.data_type) {
    case 'integer':
    case 'decimal':
    case 'money': return 'number';
    case 'date': return 'date';
    case 'boolean': return 'checkbox';
    case 'choice': return 'select';
    default: return 'text';
  }
}

export function groupFieldsBySection(fields: FieldSchema[]): Record<string, FieldSchema[]> {
  const out: Record<string, FieldSchema[]> = {};
  for (const f of fields) (out[f.section] ??= []).push(f);
  return out;
}

export function buildDynamicSchema(fields: FieldSchema[]) {
  const shape: Record<string, ZodTypeAny> = {};
  for (const f of fields) {
    let base: ZodTypeAny;
    if (['integer', 'decimal', 'money'].includes(f.data_type)) {
      let n = z.coerce.number();
      const v = f.validation as { min?: number; max?: number };
      if (typeof v.min === 'number') n = n.min(v.min);
      if (typeof v.max === 'number') n = n.max(v.max);
      base = n;
    } else if (f.data_type === 'boolean') {
      base = z.coerce.boolean();
    } else {
      let s = z.string();
      const v = f.validation as { regex?: string };
      if (v.regex) s = s.regex(new RegExp(v.regex));
      base = f.is_required ? s.min(1) : s;
    }
    shape[f.key] = f.is_required ? base : base.optional();
  }
  return z.object(shape);
}
